<template>
  <div :class="$vuetify.breakpoint.width < 800 ? 'table-xs' : 'table-md'" class="product-info-table">
    <v-data-table
      :headers="headers"
      :items="properties"
      hide-default-footer
      class="no--hover"
    >
      <template v-slot:item="{ item }">

        <tr>
          <product-info-table-data-cell :content="item.name"/>
          <product-info-table-data-cell :content="item.standard"
                                        class="text-center"/>
          <product-info-table-data-cell :content="item.expert"
                                        class="text-center"/>
          <product-info-table-data-cell :content="item.prestige"
                                        class="text-center"/>
        </tr>

      </template>
    </v-data-table>
  </div>
</template>

<script>
  import ProductInfoTableDataCell from "@/components/productInfo/ProductInfoTableDataCell";

  export default {
    name: "ProductInfoTable",
    components: {ProductInfoTableDataCell},
    data: function () {
      return {
        headers: [
          {
            text: '',
            value: 'name',
            sortable: false,
            align: 'center'
          },
          {
            text: 'Standard',
            value: 'standard',
            sortable: false,
            align: 'center',
            width: '140px'
          },
          {
            text: 'EXPERT',
            value: 'expert',
            sortable: false,
            align: 'center',
            width: '140px'
          },
          {
            text: 'PRESTIGE',
            value: 'prestige',
            sortable: false,
            align: 'center',
            width: '140px'
          }
        ],
        properties: [
          {
            name: 'Vorsorgerechtsschutz für neu hinzukommende Risiken',
            standard: 'yes',
            expert: 'yes',
            prestige: 'yes'
          },
          {
            name: 'Garantierter Einschluss von beitragsneutralen Leistungsverbesserungen',
            standard: 'yes',
            expert: 'yes',
            prestige: 'yes'
          },
          {
            name: 'Verzicht auf die Selbstbeteiligung bei Erledigung durch anwaltliche Erstberatung',
            standard: 'no',
            expert: 'yes',
            prestige: 'yes'
          },
          {
            name: 'Mitversicherung der im Haushalt lebenden Eltern, Schwiegereltern und Großeltern',
            standard: 'no',
            expert: 'sofern im Ruhestand',
            prestige: 'yes'
          },
          {
            name: 'Arbeits-Rechtsschutz: Kostenübernahme auch bei Aufhebungsvereinbarungen',
            standard: 'no',
            expert: 'bis 1.000 €',
            prestige: 'bis 2.500 €'
          },
          {
            name: 'Kostenübernahme bei bestimmten Kapitalanlagegeschäften, auch fondsgestützte Lebens- und Rentenversicherungen',
            standard: 'no',
            expert: 'bis 20.000 €',
            prestige: 'bis 20.000 €'
          },
          {
            name: 'Kostenübernahme Rechtsschutz für Photovoltaik-, Solar- und Windenergieanlagen ',
            standard: 'no',
            expert: 'bis 15.000 €',
            prestige: 'bis 25.000 €'
          },
          {
            name: 'Versicherungssumme',
            standard: "Europa 1&nbsp;Mio.&nbsp;€, weltweit 250.000 €",
            expert: 'Europa und weltweit unbegrenzt',
            prestige: 'Europa und weltweit unbegrenzt'
          }
        ]
      };
    }
  };
</script>

<style>

.product-info-table.table-md table tbody tr td {
  font-size: 16px !important;
  padding: 8px 24px !important;
}

.product-info-table.table-xs td {
  padding: 0 0 !important;
}

</style>

